export default __webpack_public_path__ + "static/media/exhibition2.5099c0ba.png";